document.addEventListener('DOMContentLoaded', function() {
  function hideMoreOptionsInShadow(shopifyBtn) {
    if (shopifyBtn && shopifyBtn.shadowRoot) {
      shopifyBtn.shadowRoot.querySelectorAll('button[aria-label]').forEach(function(shadowBtn) {
        if (/more payment options|weitere bezahlmöglichkeiten/i.test(shadowBtn.textContent)) {
          shadowBtn.style.display = 'none';
        }
      });
    }
  }

  function hideAll() {
    // Regular DOM
    document.querySelectorAll('.shopify-payment-button__more-options').forEach(function(btn) {
      btn.style.display = 'none';
    });

    // All shadow DOMs
    document.querySelectorAll('shopify-payment-button').forEach(hideMoreOptionsInShadow);
  }

  // Initial hide
  hideAll();

  // Observe the whole document for new shopify-payment-button elements
  var docObserver = new MutationObserver(function() {
    hideAll();
  });

  docObserver.observe(document.body, { childList: true, subtree: true });

  // Fallback: run every 500ms for 10 seconds
  var tries = 0;
  var maxTries = 20;
  var interval = setInterval(function() {
    hideAll();
    tries++;
    if (tries > maxTries) clearInterval(interval);
  }, 500);

}); 